/**
 * LocationVenueSetupService
 * Service for LocationVenueSetup entity operations
 * Route: api/locationvenuesetups
 * Controller: LocationVenueSetupsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * LocationVenueSetupService
 * Handles location venue setup CRUD operations
 * Maps to /api/locationvenuesetups endpoint
 */
export class LocationVenueSetupService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LocationVenueSetupService.DEFAULT_SERVICE_PATH,
            basePath: LocationVenueSetupService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Delete a location venue setup by its composite key (VenueID + SetupID)
     * DELETE /api/locationvenuesetups/{venueId}/{setupId}
     * @param venueId - Venue ID
     * @param setupId - Setup ID
     * @returns True if deleted successfully
     */
    async deleteByKey(venueId, setupId) {
        const response = await this.deleteByKeyRaw(venueId, setupId);
        return response.success;
    }
    /**
     * Delete a location venue setup by its composite key (raw)
     * @param venueId - Venue ID
     * @param setupId - Setup ID
     * @returns ResponseData (success/fail)
     */
    deleteByKeyRaw(venueId, setupId) {
        const endpoint = this.getEndpoint('deleteByKey', `${venueId}/${setupId}`);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
LocationVenueSetupService.DEFAULT_SERVICE_PATH = 'meetings';
LocationVenueSetupService.BASE_PATH = 'api/locationvenuesetups';
//# sourceMappingURL=LocationVenueSetupService.js.map